import type {DiffLine} from '@github-ui/diff-lines'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

export type ContextLineRange = {
  start: number
  end: number
}

export type ContextLineResponse = {
  diffEntryWithContext: DiffLine[]
}

function getRangesAsSeparateURLParams(contextLineRanges: ContextLineRange[]) {
  let returnString = ''
  for (let i = 0; i < contextLineRanges.length; i++) {
    returnString += `&lineRanges[]=${JSON.stringify(contextLineRanges[i])}`
  }
  return returnString
}

export function useLoadInjectedContextLines() {
  async function getInjectedContextLines(
    contextLineRanges: ContextLineRange[],
    url: string,
    pathDigest: string,
  ): Promise<ContextLineResponse | undefined> {
    const response = await verifiedFetchJSON(
      `${url}?pathDigest=${pathDigest}${getRangesAsSeparateURLParams(contextLineRanges)}`,
    )

    if (response.ok) {
      const data = await response.json()

      return data ?? undefined
    }
  }

  return getInjectedContextLines
}
